import { jsx } from '@emotion/react';
import { daysFromNow } from '@zapier/date';
import { Alert, Link } from '@zapier/design-system';
import { Price } from '@zapier/currency';
import { UserInteractionEvent } from '../../../../universal-nav/utils/avroEvents';
import { Fragment } from 'react';
import { getProfessionalPlanData } from './utils';
export const shouldRender = (data, isExcludedUrl = false) => {
    const { isTrialing, trialEndDate } = data.currentAccount;
    return !!isTrialing && !!trialEndDate && !isExcludedUrl;
};
export const Component = function ProfessionalTrialing(props) {
    const { data, currency } = props;
    const { currentAccount, possiblePlans } = data;
    const { trialEndDate } = currentAccount;
    const trialDaysRemaining = daysFromNow(trialEndDate);
    const daysText = trialDaysRemaining === 1 ? 'day' : 'days';
    const { professionalUpgradeUrl, professionalPlanAmount } = getProfessionalPlanData(possiblePlans);
    const upgradeUrl = professionalUpgradeUrl;
    const nextPlanAmount = professionalPlanAmount;
    const onClickLink = ({ interactionGoal }) => {
        props.trackEvent(UserInteractionEvent, {
            interaction_name: 'professional_trial_banner_cta_clicked',
            interaction_goal: interactionGoal,
            event_action: 'click',
            option_selected: 'not_applicable',
        });
    };
    return (jsx(Alert, { layout: props.layout, title: "Welcome to your Professional trial!", type: "info" },
        jsx("p", { "data-zds": true },
            `You have ${trialDaysRemaining} ${daysText} to try Zapier’s `,
            jsx(Link, { href: "https://help.zapier.com/hc/en-us/articles/8496197192461-Get-started-with-your-free-Zapier-trial", onClick: () => onClickLink({ interactionGoal: 'learn_more' }) }, "paid features"),
            ".",
            ' ',
            jsx(Fragment, null,
                jsx(Link, { href: upgradeUrl, onClick: () => onClickLink({ interactionGoal: 'upgrade_plan' }) }, "Upgrade"),
                ' ',
                "anytime",
                nextPlanAmount > 0 && (jsx("span", { "data-zds": true },
                    ' ',
                    "for as low as ",
                    jsx(Price, { currency: currency }, nextPlanAmount),
                    "/month."))))));
};
//# sourceMappingURL=ProfessionalTrialing.js.map
// @zapier/universal-layout@9.14.0 (b13df7b0f)
